import { createContext, useContext, useState, useEffect } from "react";

const TranslationContext = createContext();

export const TranslationProvider = ({ children }) => {
  const [translations, setTranslations] = useState({});
  const [lang, setLang] = useState(localStorage.getItem("language") || "uz");

  // Загружаем кэш при старте
  useEffect(() => {
    const cached = localStorage.getItem("translations");
    if (cached) {
      try {
        setTranslations(JSON.parse(cached));
      } catch (err) {
        console.error("Ошибка чтения кэша переводов", err);
      }
    }

    // Запрашиваем с сервера и обновляем
    fetch("https://api.rasulova-academy.uz/api/tizimdaginomlar/")
      .then(res => res.json())
      .then(data => {
        const map = {};
        data.forEach(item => {
          map[item.key] = {
            uz: item.value_uz,
            ru: item.value_ru,
            en: item.value_en
          };
        });
        setTranslations(map);
        localStorage.setItem("translations", JSON.stringify(map));
      })
      .catch(err => {
        console.error("Ошибка загрузки переводов", err);
      });
  }, []);

  const t = (key) => translations[key]?.[lang] || key;

  const changeLang = (newLang) => {
    setLang(newLang);
    localStorage.setItem("language", newLang);
  };

  return (
    <TranslationContext.Provider value={{ t, lang, setLang: changeLang }}>
      {children}
    </TranslationContext.Provider>
  );
};

export const useAppTranslation = () => useContext(TranslationContext);
